export default ({ app }) => {
  app.router.beforeEach((to, from, next) => {
    if (typeof document.startViewTransition === 'function') {
      document.startViewTransition();
    }

    next();
  });
};
